'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Options;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Options(_ref) {
  var options = _ref.options;
  return options.map(function (option, index) {
    var key = 'option-' + index;
    return _react2["default"].createElement('option', {
      value: option.value,
      disabled: option.disabled,
      key: key
    }, option.label);
  });
}

Options.propTypes = {
  options: _propTypes2["default"].array.isRequired
};